export default __webpack_public_path__ + "static/media/Maira.ea4be0dd.jpg";